import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import useFetching from "../utils/Fetching";

export function useAdminStatus() {
  const [isAdmin, setIsAdmin] = useState(null);
  const { getAccountInfo } = useFetching();
  const instance = useMsal();

  useEffect(() => {
    async function fetchAccountInfo() {
      const response = await getAccountInfo();
      const role = response.jobTitle.toUpperCase();
      const userId = response.userPrincipalName;
      // Für debug
      //const role = "Prokurist / Managing Consultant";

      if (
        role.includes("MANAGING CONSULTANT") ||
        role.includes("GESCHÄFTSFÜHRER") ||
        role.includes("PROKURIST") ||
        role.includes("ASSISTENZ DER GESCHÄFTSFÜHRUNG") ||
        role.includes("OFFICE MANAGEMENT") ||
        userId.includes("bt0419") || // For debugging
        userId.includes("bt0415") || // For debugging
        userId.includes("bt0416") 
      ) {
        setIsAdmin(true);
      } else {
        setIsAdmin(false);
      }
    }
    try {
      fetchAccountInfo();
    } catch (error) {
      console.error(error.message);
    }
  }, [instance]);

  return isAdmin;
}
